import React, { FC, useEffect, useState } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { Card, CardBody, CardSubtitle, CardTitle, Col, ListGroup, ListGroupItem, Row } from "reactstrap";
import { formatCurrency } from "../../../utils/formats";
import invoicesService from "../../../services/invoices.service";
import { toast } from "react-toastify";
import { quarterOfYear, select2Styles } from "../../../helpers/functions_helper";
import { yearOptions } from "../../../helpers/functions_helper";
import { options } from "../../../common/staticdata";
import { noData } from "../../../utils/data";
import LoadingSpinner from "../../../components/Common/Loader";
import Chart from "../../../components/Chart";

type TaskAmountVsServiceChargeProps = {
    hideHeading?: boolean;
}
const InvoiceGeneratedFromGeneralAccount: FC<TaskAmountVsServiceChargeProps> = ({ hideHeading = false }) => {

    const { t } = useTranslation();

    const [loadingText, setLoadingText] = useState<string>('Loading...');
    const [loading, setLoading] = useState<boolean>(true);
    const [formValues, setFormValues] = useState<any>({
        service_charge: quarterOfYear(),
    })

    const [d2Chart, setD2Chart] = useState<any>({
        options: {
            plotOptions: {
                pie: {
                    donut: {
                        size: '60%'
                    },

                }
            },
            colors: ['#fbf103', '#34c38e'],
            labels: ['700100', '700300'],
            legend: {
                show: true,
                position: 'bottom',
            },
            yaxis: {
                labels: {
                    formatter: function (value: any) {
                        return formatCurrency(value);
                    }
                },
            },

        },
        series: [44, 55],

    })


    const getTotalVsService = async (range: any) => {
        setLoadingText("Loading...");
        try {
            const res = await invoicesService.getAccount(range);
            if (res.status === 'success') {
                console.log("Data", res);
                setD2Chart((state: any) => ({ ...state, series: res.data?.map((x: any) => x.count), options: { ...state.options, noData: noData } }))
            }
            setLoadingText("No data found");
            setLoading(false);
        } catch (error: any) {
            toast(error)
        }
    }

    useEffect(() => {
        setLoading(true);
    }, [formValues.service_charge])

    useEffect(() => {
        loading && getTotalVsService(formValues.service_charge);
    }, [loading])


    return (
        <div style={{ height: '375px' }}>
            <div className="d-sm-flex flex-wrap">
                <div>
                    {!hideHeading && <CardTitle className="mb-3">{t("Invoice Generated from General Account")}</CardTitle>}
                </div>
                <div className="ms-auto">
                    <Select
                        id="service_charge"
                        name="service_charge"
                        className="form-select-sm myClassName"
                        styles={select2Styles}
                        value={options.find((i: any) => i.value === formValues.service_charge)}
                        options={options}
                        onChange={(option: any) => {
                            setFormValues((state: any) => ({ ...state, service_charge: option.value }))
                        }}
                    />
                </div>
            </div>
            <Chart loading={loading} options={d2Chart.options} series={d2Chart.series} type="donut" height={350} />
        </div>

    )
}

export default InvoiceGeneratedFromGeneralAccount;